export default __webpack_public_path__ + "static/media/filter.9ae1a981.svg";